import { ICustomOccasion } from './occasion-repeat'
import { IEvent } from './event-repeat'

// Occasions are all-day events. The original calendar date is retained
// separately from any calculated occurrence, including leap-day fallbacks.
export function occasionEvent(o: ICustomOccasion): IEvent {
    const { jy, jm, jd, gy, gm, gd, hy, hm, hd } = o
    return {
        id: o.id, kind: 'occasion', title: o.title, allDay: true,
        start: new Date(gy, gm - 1, gd).getTime(),
        end: new Date(gy, gm - 1, gd + 1).getTime(),
        repeat: o.repeat === 'none' ? { freq: 'none', interval: 1 }
            : { freq: 'yearly', interval: 1, calendar: o.repeat },
        occasionDate: { jy, jm, jd, gy, gm, gd, hy, hm, hd },
        reminder: o.reminder, source: o.source, seq: o.seq,
    }
}

export function eventOccasion(e: IEvent): ICustomOccasion | undefined {
    if (e.kind !== 'occasion' || !e.occasionDate) return undefined
    return { ...e.occasionDate, id: e.id, title: e.title, reminder: e.reminder,
        repeat: e.repeat.freq === 'none' ? 'none' : e.repeat.calendar || 'gregorian',
        source: e.source, seq: e.seq }
}

export interface OccasionMigration {
    save(event: IEvent): Promise<void>
    removeLegacy(id: string): Promise<void>
}

// Re-runnable after interruption: persist the event (or durable storage retry)
// before removing the old row. Preserve IDs unless an unrelated event owns one.
export async function migrateOccasions(existing: IEvent[], legacy: ICustomOccasion[],
    storage: OccasionMigration): Promise<IEvent[]> {
    const migrated = [...existing]
    for (const occasion of legacy) {
        if (!migrated.some(e => e.legacyOccasionId === occasion.id)) {
            let id = occasion.id
            while (migrated.some(e => e.id === id)) id = 'occasion:' + id
            const event = { ...occasionEvent({ ...occasion, id }), legacyOccasionId: occasion.id }
            await storage.save(event)
            migrated.push(event)
        }
        await storage.removeLegacy(occasion.id)
    }
    return migrated
}
